"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../../config/types");
const onchainPoolToken_1 = __importDefault(require("../../onchainPoolToken"));
class OnchainBorrowable extends onchainPoolToken_1.default {
    constructor(lendingPool, poolTokenType) {
        super();
        this.borrowableCache = {};
        this.getLendingPool = () => this.lendingPool;
        this.getPoolTokenType = () => this.poolTokenType;
        this.getContractHelper = () => this.lendingPool.getImpermaxFactory().getOnchain().getContractHelper();
        this.getOffchainBorrowable = this.getOffchainPoolToken;
        // Impermax Chef
        this.getImpermaxChef = () => this.getContractHelper().impermaxChef;
        this.lendingPool = lendingPool;
        this.poolTokenType = poolTokenType;
    }
    cleanCache() {
        super.cleanCache();
        this.borrowableCache = {};
    }
    getPoolTokenAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.lendingPool.getPoolTokenAddresses())[this.poolTokenType];
        });
    }
    getOffchainPoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPool = yield this.lendingPool.getOffchainLendingPool();
            return lendingPool.getPoolToken(this.poolTokenType);
        });
    }
    initializePoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getContractHelper().newBorrowable(yield this.getPoolTokenAddress());
        });
    }
    initializeToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolToken = yield this.getPoolToken();
            return this.getContractHelper().newERC20(yield poolToken.methods.underlying().call());
        });
    }
    // Price Denom LP
    getPriceDenomLP() {
        return __awaiter(this, void 0, void 0, function* () {
            const prices = yield this.lendingPool.getPriceDenomLP();
            return prices[this.poolTokenType === types_1.PoolTokenType.BorrowableA ? 0 : 1];
        });
    }
    getMarketPriceDenomLP() {
        return __awaiter(this, void 0, void 0, function* () {
            const prices = yield this.lendingPool.getMarketPriceDenomLP();
            return prices[this.poolTokenType === types_1.PoolTokenType.BorrowableA ? 0 : 1];
        });
    }
    // Farming Pool
    initializeBorrowTracker() {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowable = yield this.getPoolToken();
            return borrowable.methods.borrowTracker().call();
        });
    }
    getBorrowTracker() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.borrowableCache.borrowTracker)
                this.borrowableCache.borrowTracker = this.initializeBorrowTracker();
            return this.borrowableCache.borrowTracker;
        });
    }
    hasFarming() {
        return __awaiter(this, void 0, void 0, function* () {
            // remove old farming contracts, now it only has farming if it has the impermaxChef
            return this.hasImpermaxChef();
        });
    }
    hasImpermaxChef() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const borrowTracker = yield this.getBorrowTracker();
            return borrowTracker.toLowerCase() === ((_a = this.getImpermaxChef()._address) !== null && _a !== void 0 ? _a : "").toLowerCase();
        });
    }
    initializeFarmingTokenSymbol() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.hasImpermaxChef()))
                return "";
            const impermaxChef = yield this.getImpermaxChef();
            const farmingTokenAddress = yield impermaxChef.methods.rewardToken().call();
            return this.getContractHelper().newERC20(farmingTokenAddress).methods.symbol().call();
        });
    }
    getFarmingTokenSymbol() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.borrowableCache.farmingTokenSymbol)
                this.borrowableCache.farmingTokenSymbol = this.initializeFarmingTokenSymbol();
            return this.borrowableCache.farmingTokenSymbol;
        });
    }
    // Farming Pool Rewarder
    initializeRewarder() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolTokenAddress = yield this.getPoolTokenAddress();
            try {
                const { rewarder } = yield this.getImpermaxChef().methods.poolInfo(poolTokenAddress).call();
                if (rewarder == "0x0000000000000000000000000000000000000000")
                    return null;
                return this.getContractHelper().newImpermaxChef(rewarder);
            }
            catch (_a) {
                return null;
            }
        });
    }
    getRewarder() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.borrowableCache.rewarder)
                this.borrowableCache.rewarder = this.initializeRewarder();
            return this.borrowableCache.rewarder;
        });
    }
    hasRewarder() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getRewarder()) !== null;
        });
    }
    initializeRewarderTokenSymbol() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.hasRewarder()))
                return "";
            const rewarder = yield this.getRewarder();
            const rewardTokenAddress = yield rewarder.methods.rewardToken().call();
            return this.getContractHelper().newERC20(rewardTokenAddress).methods.symbol().call();
        });
    }
    getRewarderTokenSymbol() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.borrowableCache.rewarderTokenSymbol)
                this.borrowableCache.rewarderTokenSymbol = this.initializeRewarderTokenSymbol();
            return this.borrowableCache.rewarderTokenSymbol;
        });
    }
}
exports.default = OnchainBorrowable;
